import { cn } from '../../utils/helpers';
import { t } from '../../i18n';

export type PersonMode = 'list' | 'name';

/** Switch between picking a worker from the list and typing a name by hand. */
export function PersonModeToggle({ value, onChange }: { value: PersonMode; onChange: (mode: PersonMode) => void }) {
  const option = (mode: PersonMode, label: string) => (
    <button
      type="button"
      onClick={() => onChange(mode)}
      aria-pressed={value === mode}
      className={cn(
        'flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
        value === mode ? 'bg-white text-primary-700 shadow-sm' : 'text-secondary-600 hover:text-secondary-900',
      )}
    >
      {label}
    </button>
  );
  return (
    <div className="mb-2 flex gap-1 rounded-lg bg-secondary-100 p-1" role="group" aria-label={t('Pracovník zo zoznamu alebo iné meno')}>
      {option('list', t('Zo zoznamu pracovníkov'))}
      {option('name', t('Iné meno (napísať)'))}
    </div>
  );
}
